import * as React from 'react';
import { createPortal } from 'react-dom';
import { observer } from 'mobx-react';
import { translation } from 'easit--localization';
import { ProgressContent } from 'common--design-library';
import { EventsPopup, ILeftMenuCategoryPopupEvent, Nav, Navbar } from 'desktop--design-library';
import { ILiveCategoryStore } from '../../models/live/liveCategory';
import { LeftMenuCategoryContainer } from './leftMenuCategoryContainer';
import { pushToSearch } from '../../liveRouting';
import { IDesktopLiveEventListStore, IMtsTicketStore, IOdd, OfferType } from 'eTip--common';
import { ILiveEventListStore } from '../../models/live/liveEventList';
import { Instance } from 'mobx-state-tree';
import { SearchStore } from '../../models/live/searchStore';
import * as classnames from 'classnames';

export interface ILeftMenuContainerProps {
    events: ILiveEventListStore;
    ticketWrapper: IMtsTicketStore;
    search: Instance<typeof SearchStore>;
    isLeftColumnCollapsed: boolean;
    toggleLeftColumnExpand: () => void;
    setEventIsFavorite: (eventId: number, isFavorite: boolean) => void;
    setCategoryAsFavorite: (category: ILiveCategoryStore) => void;
}

const FavoriteCategoryId = -1;

@observer
export class LeftMenuContainer extends React.Component<ILeftMenuContainerProps> {

    constructor(props: ILeftMenuContainerProps) {
        super(props);
    }

    private searchTimer: number;

    private autoSearch() {
        this.searchTimer = window.setTimeout(() => {
            if (this.searchStore.searchText.length > 2) {
                pushToSearch(this.searchStore.searchText);
            }
            window.clearTimeout(this.searchTimer);
        }, 500)
    }

    componentWillMount() {
        this.props.events.updateIsExpandedInCategoriesOnLeftMenu();
    }

    componentWillUnmount() {
        this.store.setCategoryIdForOpenedEventsPopup(0);
    }

    private lastRenderTelemetryContext: number;
    componentWillUpdate() {
        this.lastRenderTelemetryContext = this.store.leftColumnRenderTelemetry.start();
    }

    componentDidUpdate() {
        this.store.leftColumnRenderTelemetry.finish(this.lastRenderTelemetryContext);
    }

    get store() {
        return this.props.events;
    }

    get ticketStore() {
        return this.props.ticketWrapper;
    }

    get searchStore() {
        return this.props.search;
    }

    get favoriteEvents() {
        let ret: ILeftMenuCategoryPopupEvent[] = [];
        this.store.favoriteCats.forEach(favCat => {
            favCat.events.forEach(event => {
                ret.push({
                    id: event.id,
                    isFavorite: true,
                    name: event.name,
                    hasResults: event.hasResults,
                    mainResult: event.mainResult,
                    stateName: event.stateName,
                    eventTime: event.eventTime
                })
            })
        })
        return ret;
    }

    render() {
        const t = translation();
        return (
            <Navbar className={`nav-tree category-tree`}>
                <div className="w-100 d-flex">
                    {
                        !this.props.isLeftColumnCollapsed &&
                        <div className={classnames("search-wrapper", __IsMTSTipos__ ? "mb-0" : null)}>
                            <input type="text" value={this.searchStore.searchText} placeholder={translation().search}
                                onChange={value => { this.searchStore.setSearchText(value.currentTarget.value); this.autoSearch(); }}
                            />
                            <span className="fa fa-search search-icon" onClick={() => { pushToSearch(this.searchStore.searchText) }}></span>
                        </div>
                    }
                    <div className="btn btn-primary ml-auto" onClick={() => {
                        this.props.toggleLeftColumnExpand();
                        if (this.props.isLeftColumnCollapsed) {
                            this.store.setCategoryIdForOpenedEventsPopup(0);
                        }
                    }}>
                        <span className={`fa fa-lg fa-angle-double-${this.props.isLeftColumnCollapsed ? 'right' : 'left'}`}></span>
                    </div>
                </div>
                {
                    this.store.favoriteCats.length > 0 &&
                    <React.Fragment>
                        {
                            this.props.isLeftColumnCollapsed
                                ? <div className="left-menu-category-collapsed w-100"
                                    onClick={(e) => this.store.setCategoryIdForOpenedEventsPopup(FavoriteCategoryId, e.clientY)}
                                >
                                    <span className="favorite-category"><span className="far fa-star ml-1"></span><span>({this.store.favoritesEventCount})</span></span>
                                    {
                                        this.store.categoryIdForOpenedEventsPopup === FavoriteCategoryId &&
                                        createPortal(
                                            <EventsPopup
                                                sportName={t.desktopLive_FavoriteEvents}
                                                categoryName={t.desktopLive_FavoriteEvents}
                                                eventCount={this.store.favoritesEventCount}
                                                events={this.favoriteEvents}
                                                onSetAsFavorite={(eventId: number, isFavorite: boolean) => {
                                                    this.props.setEventIsFavorite(eventId, !isFavorite);
                                                }}
                                                goToDetail={() => { }}
                                                onToggleEventsPopupVisible={() => {
                                                    this.store.setCategoryIdForOpenedEventsPopup(FavoriteCategoryId)
                                                }}
                                                popupOffset={this.store.eventsPopupOffset}
                                            />
                                            , document.body)
                                    }
                                </div>
                                : this.renderCategoriesTree(this.store.favoriteCats, this.store.favoritesEventCount, true)
                        }
                    </React.Fragment>
                }
                {
                    this.renderCategoriesTree(this.store.categories, this.store.categoriesEventCount, false)
                }
            </Navbar>
        );
    }

    private renderCategoriesTree(categories: ILiveCategoryStore[], eventCount: number, isFavorites: boolean) {
        const t = translation();
        return (
            <React.Fragment>
                {
                    !this.props.isLeftColumnCollapsed &&
                    <div className="group-header">{isFavorites ? t.desktopLive_FavoriteEvents : t.desktopLive_OpenEvents} ({eventCount})</div>
                }

                <Nav key={isFavorites ? "favs" : "cats"} navbar vertical>
                    <ProgressContent state={this.store.state}>
                        {
                            categories.map((category: ILiveCategoryStore) => <LeftMenuCategoryContainer
                                key={category.id}
                                isLeftColumnCollapsed={this.props.isLeftColumnCollapsed}
                                category={category}
                                activeTips={this.ticketStore.activeTips}
                                inactiveTips={this.ticketStore.inactiveTips}
                                onSelectTip={(odd: IOdd, event: IDesktopLiveEventListStore) => {
                                    this.ticketStore.oddsSetTipOnCouponAsync(
                                        odd,
                                        {
                                            eventName: event.name,
                                            eventDate: event.startDate,
                                            gameName: event.gameAndDetailForLeftMenu.game.name,
                                            hasDetail: event.gameAndDetailForLeftMenu.game.hasDetails,
                                            detailName: event.gameAndDetailForLeftMenu.detail.name,
                                            number: event.gameAndDetailForLeftMenu.detail.number,
                                            offerType: OfferType.Live
                                        });
                                }}
                                onSetAsFavorite={(eventId: number, isFavorite: boolean) => {
                                    this.props.setEventIsFavorite(eventId, !isFavorite);
                                }}
                                onToggleExpand={() => {
                                    category.toggleIsExpandedInLeftMenu();
                                    this.store.storeCollapsedCategory(category.id, category.isExpandedInLeftMenu);
                                }}
                                onToggleEventsPopupVisible={(offset: number) => {
                                    this.store.setCategoryIdForOpenedEventsPopup(category.id, offset)
                                }}
                                isEventPopUpVisible={(this.store.categoryIdForOpenedEventsPopup === category.id)}
                                popupOffset={this.store.eventsPopupOffset}
                                isFavorite={isFavorites}
                                onSetCategoryFavorite={() => { this.props.setCategoryAsFavorite(category) }}
                                onMatchTrackerClick={(event: IDesktopLiveEventListStore) => { this.props.events.rightSideStreamWrapper.open({ id: event.id, matchId: event.matchTracker.id, type: event.matchTracker.type, title: event.name, graphicsPresentationId: category.graphicsPresentationId }); }}
                            />)
                        }
                    </ProgressContent>
                </Nav>
            </React.Fragment>
        );
    }
}
